import { render, staticRenderFns } from "./ModalActiveAccount.vue?vue&type=template&id=747e3ddd&scoped=true"
import script from "./ModalActiveAccount.vue?vue&type=script&lang=js"
export * from "./ModalActiveAccount.vue?vue&type=script&lang=js"
import style0 from "./ModalActiveAccount.vue?vue&type=style&index=0&id=747e3ddd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747e3ddd",
  null
  
)

export default component.exports